<b>Please choose a phone to configure from the list</b>
<br/><br/>
<ul *ngIf="pendingPhoneList() | async as phoneList">
  <ng-container *ngIf="phoneList.length; else noItems">
      <li *ngFor="let phone of phoneList">
        <div >
          <a (click)="configurePhone(phone)">{{ phone.macAddr }} </a> (connected on {{phone.connectionTime}})
        </div>
      </li>
  </ng-container>
  <ng-template #noItems> No IP Phone detected. Please plug or reboot it</ng-template>
</ul>
